import { defaultMillisecondsToLive, fetchFunctionType, IMemoryCache } from './MemoryCache.models';
import { MemoryCacheItem } from './MemoryCacheItem';

export class MemoryCache implements IMemoryCache {
    private cacheItems: Map<string, MemoryCacheItem> = new Map<string, MemoryCacheItem>();
    private millisecondsToLive: number = defaultMillisecondsToLive;

    public constructor(millisecondsToLive: number = defaultMillisecondsToLive) {
        this.millisecondsToLive = millisecondsToLive;
    }

    public add = (key: string, fetchFunction: fetchFunctionType, millisecondsToLive: number | null = null): void => {
        if (!key) {
            throw new RangeError('No key provided');
        }
        if (!fetchFunction) {
            throw new RangeError('No get function provided');
        }
        this.cacheItems[key] = new MemoryCacheItem(fetchFunction, millisecondsToLive || this.millisecondsToLive);
    };

    public delete = (key: string): void => {
        if (!key) {
            throw new RangeError('No key provided');
        }
        delete this.cacheItems[key];
    };

    public get = (key: string): Promise<any> => {
        if (!key) {
            throw new RangeError('No key provided');
        }
        const item: MemoryCacheItem = this.cacheItems[key];
        if (item) {
            return item.getData();
        }

        return Promise.resolve();
    };

    public getOrAdd = (key: string, fetchFunction: fetchFunctionType, millisecondsToLive: number | null = null): any => {
        if (!key) {
            throw new RangeError('No key provided');
        }
        let item: MemoryCacheItem = this.cacheItems[key];
        if (item) {
            return item.getData();
        } else {
            this.add(key, fetchFunction, millisecondsToLive);
        }

        item = this.cacheItems[key];
        if (item) {
            return item.getData();
        }

        return Promise.resolve();
    };

    public resetCache(): void {
        this.cacheItems.forEach((item): void => item.resetCache());
        this.cacheItems.clear();
    }
}
